/* Vibes wishlist — Lab89, 2026-09-16 (colourway keys added 2026-09-29)
 * One store for every bookmark on the site (product page + product cards).
 * localStorage 'vibes_wishlist'          = ["<key>", ...]
 * localStorage 'vibes_wishlist_handles'  = {"<key>": "<handle>"}
 * <key> is "<productId>:<variantId>" for a saved colourway, or "<productId>" for a frame
 * (frame-level keys are what everything saved before 29 Sep uses; they keep working).
 * This script owns all toggling — cards and the product page button alike.
 */
(function () {
  var KEY = 'vibes_wishlist';
  var HKEY = 'vibes_wishlist_handles';
  var PAGE = '/pages/wishlist';

  function read(k, fallback) {
    try { var v = JSON.parse(localStorage.getItem(k)); return v || fallback; } catch (e) { return fallback; }
  }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  function handleFor(btn) {
    if (btn.classList.contains('js-product-wishlist')) {
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    }
    var el = btn.parentElement;
    while (el && el !== document.body) {
      var a = el.querySelector('a[href*="/products/"]');
      if (a) {
        var mm = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
        return mm ? decodeURIComponent(mm[1]) : null;
      }
      el = el.parentElement;
    }
    return null;
  }

  // Product page: the colourway currently selected in the product form.
  function pdpVariantId(btn) {
    var form = (btn.closest('section') || document).querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (form && form.value) return String(form.value);
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  function keyFor(btn) {
    var pid = String(btn.dataset.productId);
    if (btn.classList.contains('js-product-wishlist')) {
      var v = pdpVariantId(btn);
      return v ? pid + ':' + v : pid;
    }
    return String(btn.dataset.wishlistKey || pid);
  }
  // A colourway button also shows as saved if the whole frame was saved the old way.
  function isSaved(list, key, pid) {
    return list.indexOf(key) > -1 || (key !== pid && list.indexOf(pid) > -1);
  }

  function sync() {
    var list = read(KEY, []).map(String);
    var handles = read(HKEY, {});
    var changed = false;
    document.querySelectorAll('.js-wishlist-toggle[data-product-id], .js-product-wishlist[data-product-id]').forEach(function (btn) {
      var pid = String(btn.dataset.productId);
      var key = keyFor(btn);
      var saved = isSaved(list, key, pid);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
      if (saved && list.indexOf(key) > -1 && !handles[key]) {
        var h = handleFor(btn);
        if (h) { handles[key] = h; changed = true; }
      }
    });
    if (changed) write(HKEY, handles);
  }

  var toastTimer;
  function toast(saved) {
    if (location.pathname.indexOf(PAGE) === 0) return;
    var t = document.querySelector('.vibes-wishlist-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'vibes-wishlist-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = saved
      ? '<span>Saved to wishlist</span><a href="' + PAGE + '">View</a>'
      : '<span>Removed from wishlist</span>';
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3000);
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.js-wishlist-toggle[data-product-id]');
    var pdp = e.target.closest('.js-product-wishlist[data-product-id]');
    var btn = card || pdp;
    if (!btn) return;
    var pid = String(btn.dataset.productId);
    var key = keyFor(btn);
    var list = read(KEY, []).map(String);
    var handles = read(HKEY, {});
    var saved;
    if (isSaved(list, key, pid)) {
      // Unsave: drop the colourway key and any old frame-level entry covering it.
      list = list.filter(function (x) { return x !== key && x !== pid; });
      delete handles[key]; delete handles[pid];
      saved = false;
    } else {
      list.push(key);
      var h = handleFor(btn); if (h) handles[key] = h;
      saved = true;
    }
    write(KEY, list);
    write(HKEY, handles);
    // Run after any inline handlers that flip the class, so storage always wins.
    setTimeout(function () { sync(); toast(saved); }, 0);
  });

  window.VibesWishlist = {
    ids: function () { return read(KEY, []).map(String); },
    handles: function () { return read(HKEY, {}); },
    remove: function (id) {
      id = String(id);
      write(KEY, read(KEY, []).map(String).filter(function (x) { return x !== id; }));
      var h = read(HKEY, {}); delete h[id]; write(HKEY, h);
      sync();
    },
    sync: sync
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  // Product page colour switch: re-check the bookmark for the newly selected colourway.
  var vTimer;
  function resyncSoon() { clearTimeout(vTimer); vTimer = setTimeout(sync, 60); }
  document.addEventListener('change', resyncSoon);
  document.addEventListener('variant:change', resyncSoon);
  document.addEventListener('variant:changed', resyncSoon);
  // Cards injected later (carousels, filters, infinite scroll)
  if ('MutationObserver' in window) {
    var pending;
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(sync, 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
